import { createContext } from 'react';
import type { UserInfo } from '../api/account';

export interface AuthState {
  user: UserInfo | null;
  loading: boolean;
}

export interface AuthContextValue extends AuthState {
  refreshUser: () => Promise<void>;
  markAuthenticated: () => Promise<void>;
  logout: () => Promise<void>;
}

export const AuthContext = createContext<AuthContextValue | null>(null);
